module.exports = __webpack_public_path__ + "img/NewMotoIcon.eee981b6.svg";